var btnClass = '.product .product-page .product__information .purchase-details__buttons .button--add-to-cart';

Element.prototype.appendAfterThis = function (element) {
	element.parentNode.insertBefore(this, element.nextSibling);
};

var sticky = document.createElement('div');
sticky.innerHTML = `<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"></div><div class="simple-product-stock mobile-only"></div>
</div> <div class="simple-st-container__inner"><div class="simple-product-price"><div class="simple-product-stock desktop-only"></div></div> <div class="simple-select-container"> <div class="simple-st-select" id="st-select0"> <span>Color</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select1"> <span>Type</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select2"> <span>Type</span> <select> <option></option> </select> </div></div><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">ADD TO CART</a></div></div></div></div>`;
var y = document.getElementsByTagName('body');
if (document.getElementsByClassName('simple-st-container').length == 0) {
	y[0].appendChild(sticky);

	jQuery('.simple-product-name').html(jQuery('h1.product_name.title').eq(0).html());

	let stock = jQuery('.con-tainer .subtitle .stock').eq(0).html();
	if(stock) {
		jQuery('.simple-product-stock').html(stock);
	}

	let price = jQuery('p.modal_price.subtitle').eq(0).clone();
	if (price.find('.saved-price').length > 0) {
		price.find('.saved-price').remove();
	}

	if (price.find('.eu-pricing-directive').length > 0) {
		const money = price.find('.eu-pricing-directive').find('.money').text();
		price.find('.eu-pricing-directive').html("Was: " + money);
		price.find('br').remove();
	}
	jQuery('.simple-product-price').append(price);
	// jQuery('.simple-product-price').append(jQuery('p.modal_price.subtitle').eq(0).clone());

	jQuery('.simple-st-item__button').click(function () {
		let stock = jQuery('.con-tainer .subtitle .stock').eq(0).html();
		if(stock) {
			if(stock.includes("Out")){
				// Back in stock popup style is a theme setting, so trigger whichever
				var bisTrigger = jQuery('[data-bis-trigger]').eq(0);
				if (bisTrigger.length) {
					bisTrigger.click();
				} else {
					jQuery('#klaviyo-bis-button-container button').click();
				}
			}else{
				// Warranty drawer handles all add-to-cart via its own event listener
				// It will show the drawer if warranties/installation available, or add to cart directly if not
				if (window.warrantyDrawer) {
					return;
				}
				// Fallback if warranty drawer not loaded
				jQuery('.purchase-details__buttons .button--add-to-cart').click();
			}
		}
	});
}

function checkIfDisabled() {
	setTimeout(function () {
		var elem = jQuery(btnClass).eq(0);
		let stock = jQuery('.con-tainer .subtitle .stock').eq(0).html();
		jQuery('.simple-st-item__button').html(elem.text());
		if(stock && stock.includes("Out")) {
			jQuery('.simple-st-item__button').html("NOTIFY ME WHEN AVAILABLE");
		}
		if (elem.is(':disabled')) {
			jQuery('.simple-st-item__button').html(elem.html());
			jQuery('.simple-st-item__button').addClass('simple-st-disabled');
		} else {
			jQuery('.simple-st-item__button').removeClass('simple-st-disabled');
		}
	}, 100);
}

checkIfDisabled();

function isVisible(elem) {
	var elementTop = elem.offset().top;
	var elementBottom = elementTop + elem.outerHeight();
	var viewportTop = jQuery(window).scrollTop();
	var viewportBottom = viewportTop + jQuery(window).height();
	return elementBottom > viewportTop && elementTop < viewportBottom;
}

var mc = window.matchMedia('(min-width: 767px)');

var elem = document.getElementById('simple-st-containerID');
function slideShow() {
	jQuery('body').addClass('simple-sticky');
}

function slideHide() {
	jQuery('body').removeClass('simple-sticky');
}

jQuery(document).scroll(function () {
	slideShow();
	/*var y = jQuery(this).scrollTop();
	if (y > jQuery('.purchase-details__buttons .button--add-to-cart').eq(0).offset().top) {
		slideShow();
	} else {
		slideHide();
	}*/
});
